// src/data/openRolesAdapter.js
//
// REPORTS-OPEN-ROLES: Client-side data adapter for the Open Roles report.
//
// Fetches GET /api/greenhouse/open-roles-report.
//
// Both functions are plain async functions (not a hook) so they can be
// composed into the report component's useEffect pattern matching the
// existing reportsClient.js convention.
import { getLocations } from "./locationsClient.js";
import { marketAssignment } from "../services/seatAccounting.js";

/**
 * Fetch the fractionalized open-roles report from the server.
 *
 * @returns {Promise<{
 *   markets: object[],
 *   remote: number,
 *   unmatched: number,
 *   kpis: { totalReqs: number, officeBased: number, remote: number, inPressure: number, departments: number },
 *   freshness: { pulledAt: string|null, stale: boolean },
 * }>}
 */
export async function getOpenRolesReport() {
  const res = await fetch("/api/greenhouse/open-roles-report", {
    credentials: "include",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }
  const data = await res.json();
  // Pressure's forecast totals remain unchanged. Space Fit gets its own
  // today's eligible-office population; a failed read is explicitly unscored.
  let inventory;
  try { inventory = { locations: await getLocations() }; }
  catch (error) { inventory = { error: error.message }; }
  return { ...data, markets: (data.markets ?? []).map(m => ({
    ...m, spaceFitToday: marketAssignment(inventory, m.id),
  })) };
}

export async function getOpenRolesMonthlyHistory() {
  const res = await fetch("/api/greenhouse/open-roles-monthly-history", {
    credentials: "include",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }
  return res.json();
}
